import React, { Component } from "react";
import _ from "lodash";
import { ListingContext } from "../../Context";

// import { MakeTitle } from "../../utils/consts";

import SkeletonText from "../../components/skeleton/SkeletonText";

export default class ListingTitle extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const location = listing.location || {};
          if (listingContext.loading) {
            return (
              <div className="listing-title">
                <SkeletonText lines={3} />
              </div>
            );
          } else if (!!listing.title && !_.isEmpty(location)) {
            return (
              <div className="listing-title">
                <h6 className="listing-title__type">Lease</h6>
                <h1 className="listing-title__title">{`${listing.title}`}</h1>
                <h6 className="listing-title__location">
                  {location.area && location.area} |{" "}
                  {location.city && location.city}
                </h6>
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingTitle.js